import * as BABYLON from 'babylonjs';
import * as FrustumStructures from './frustumStructures';
export var WorkerIncluded: boolean = true;
export interface SelectionContent {
    selectedNodes: any;
    UnselectedNodes: any;
}

export class FrustumRegionCache<T> {
    private _nodes: { [n: string]: FrustumStructures.TreeNode; } = {};

    private _tree: Octree<FrustumStructures.TreeNode>;

    constructor() {
        this._tree = new Octree<FrustumStructures.TreeNode>(function (node: FrustumStructures.TreeNode, block: OctreeBlock<FrustumStructures.TreeNode>) { });
        this._tree.blocks = new Array<OctreeBlock<FrustumStructures.TreeNode>>();
    }

    public getNodes(): { [n: number]: FrustumStructures.TreeNode; } {
        return this._nodes;
    }

    public addBlockContent(node: FrustumStructures.TreeNode) {


        // This should add the node to the tree in the cache!
        this._tree.addNode(node.id, node);
    }

    public addBlock(block: OctreeBlock<FrustumStructures.TreeNode>) {


        var totalEntries = this.addBlockEntries(block);
        this._tree.blockMap[block.id] = block;
        this._tree.blocks.push(block);
    }

    public addBlockEntries(block: OctreeBlock<FrustumStructures.TreeNode>): number {

        if (block == null || block.entries == null) {
            return 0;
        }
        var childCount: number = block.entries.length;

        if (block.blocks != null) {
            for (var x = 0; x < block.blocks.length; x++) {

                childCount += this.addBlockEntries(block.blocks[x]);
            }
        }


        return childCount;
    }
    public removeNode(uniqueId: string) {
        // This should delete the tree node, and all nodes below.
    }

    public getVisibleNodes(cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, lodDistances: number[], planes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport): SelectionContent {


        var blockData = this._tree.select(cameraPosition, lodDistances, cameraDirection, planes, transformation, viewport, true);

        return blockData;
    }
}

export class FrustumRegionWorker {

    constructor(private _frustumRegionCache: FrustumRegionCache<FrustumStructures.TreeNode>) {
        BABYLON.PerformanceConfigurator.MatrixTrackPrecisionChange = false;

    }



    public collideFrustumToTree() {

        //TODO CollisionsEpsilon should be defined here and not in the engine.

        // Check all meshes
        var nodes = this._frustumRegionCache.getNodes();
    }

    private checkCollision(mesh: any) {

    }
}

export interface IFrustumRegionDetector {
    onInit(payload: FrustumStructures.InitPayload): void;
    onUpdate(payload: FrustumStructures.UpdatePayload): void;
    onOrderNodes(payload: FrustumStructures.FrustumRegionPayload): void;
}

export class FrustumRegionDetectorTransferable implements IFrustumRegionDetector {
    private _frustumRegionCache: FrustumRegionCache<FrustumStructures.TreeNode>;

    public onInit(payload: FrustumStructures.InitPayload) {
        this._frustumRegionCache = new FrustumRegionCache();
        var reply: FrustumStructures.WorkerReply = {
            error: FrustumStructures.WorkerReplyType.SUCCESS,
            taskType: FrustumStructures.WorkerTaskType.INIT
        }

        postMessage(reply, undefined);
    }

    public onUpdate(payload: FrustumStructures.UpdatePayload) {
        var replay: FrustumStructures.WorkerReply = {
            error: FrustumStructures.WorkerReplyType.SUCCESS,
            taskType: FrustumStructures.WorkerTaskType.UPDATE
        }

        try {

            for (var x = 0; x < payload.updatedBlocks.length; x++) {
                this._frustumRegionCache.addBlock(payload.updatedBlocks[x] as OctreeBlock<FrustumStructures.TreeNode>);
            }

            for (var n in payload.updatedBlockContent) {

                this._frustumRegionCache.addBlockContent(payload.updatedBlockContent[n]);
            }
        } catch (x) {
            replay.error = FrustumStructures.WorkerReplyType.UNKNOWN_ERROR;
        }

        postMessage(replay, undefined);
    }

    public onOrderNodes(payload: FrustumStructures.FrustumRegionPayload) {

        var blockSelections = this._frustumRegionCache.getVisibleNodes(payload.cameraPosition, payload.cameraDirection, payload.lodDistances, payload.planes, payload.transformation, payload.viewport);


        var replyPayload: FrustumStructures.FrustumRegionReplyPayload = {
            hiddenNodes: blockSelections.UnselectedNodes,
            visibleNodes: blockSelections.selectedNodes,
            collisionId: payload.collisionId

        }

        var reply: FrustumStructures.WorkerReply = {
            error: FrustumStructures.WorkerReplyType.SUCCESS,
            taskType: FrustumStructures.WorkerTaskType.ORDERNODES,
            payload: replyPayload
        }

        postMessage(reply, undefined);
    }
}

//check if we are in a web worker, as this code should NOT run on the main UI thread
const isWorkerContext = typeof self !== 'undefined'
    && typeof (self as any).importScripts === 'function';

try {

    if (isWorkerContext) {

        var collisionDetector: IFrustumRegionDetector = new FrustumRegionDetectorTransferable();

        var onNewMessage = (event: MessageEvent) => {

            var message = <FrustumStructures.FrustmMeshMessage>event.data;

            switch (message.taskType) {
                case FrustumStructures.WorkerTaskType.INIT:
                    collisionDetector.onInit(<FrustumStructures.InitPayload>message.payload);
                    break;
                case FrustumStructures.WorkerTaskType.ORDERNODES:
                    collisionDetector.onOrderNodes(<FrustumStructures.FrustumRegionPayload>message.payload);
                    break;
                case FrustumStructures.WorkerTaskType.UPDATE:
                    collisionDetector.onUpdate(<FrustumStructures.UpdatePayload>message.payload);
                    break;
            }
        }

        self.onmessage = onNewMessage;
    }
} catch (e) {

}

export interface IOctreeContainer<T> {
    blocks: Array<OctreeBlock<T>>;
}


export class Octree<T> {
    public blocks: Array<OctreeBlock<T>>;
    public blockMap: { [n: string]: any; } = {};

    public dynamicContent = new Array<T>();

    private _maxBlockCapacity: number;
    private _unselectionContent: T[] = [];
    private _selectionContent: T[] = [];
    private _creationFunc: (entry: T, block: OctreeBlock<T>) => void;

    private _searchingSelectionBlocks: OctreeBlock<T>[] = [];
    private _completeSelectionBlocks: OctreeBlock<T>[] = [];

    private _searchingUnselectionBlocks: OctreeBlock<T>[] = [];
    private numSkipped = 0;
    constructor(creationFunc: (entry: T, block: OctreeBlock<T>) => void, maxBlockCapacity?: number, public maxDepth = 2) {
        BABYLON.PerformanceConfigurator.MatrixTrackPrecisionChange = false;
        this._maxBlockCapacity = maxBlockCapacity || 64;
        this._creationFunc = creationFunc;
    }

    // Methods
    public update(worldMin: BABYLON.Vector3, worldMax: BABYLON.Vector3, entries: T[]): void {
        Octree._CreateBlocks(worldMin, worldMax, entries, this._maxBlockCapacity, 0, this.maxDepth, this, this._creationFunc);
    }

    public addNode(blockId: string, entry: T): void {

        if (this.blockMap[blockId] == null) {
            console.log("NULL BLOCK");
        }

        this.blockMap[blockId].entries.push(entry);
    }

    public select(cameraPosition: BABYLON.Vector3, lodDistances: number[], cameraDirection: BABYLON.Vector3, frustumPlanes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, allowDuplicate?: boolean): SelectionContent {

        this._selectionContent = [];
        this._unselectionContent = [];

        try {
            for (var index = 0; index < this.blocks.length; index++) {

                var selectionContent: any[] = [];
                var unselectionContent: any[] = [];
                this._searchingSelectionBlocks = [];
                this._completeSelectionBlocks = [];
                this._searchingUnselectionBlocks = [];
                var block: OctreeBlock<T> = this.blocks[index];

                this.numSkipped = 0;
                this._searchingSelectionBlocks.push(block);

                var searchingSelectionIndex = 0;

                while (this._searchingSelectionBlocks.length != 0) {
                    var searchBlock = this._searchingSelectionBlocks.pop();

                    this.blockSelectBreadthFirst(searchBlock, lodDistances, cameraPosition, cameraDirection, frustumPlanes, transformation, viewport, selectionContent, unselectionContent, allowDuplicate);
                    while (this._completeSelectionBlocks.length > 0) {

                        this.blockSelectAllIn(this._completeSelectionBlocks.pop(), lodDistances, cameraPosition, cameraDirection, frustumPlanes, transformation, viewport, selectionContent, unselectionContent, allowDuplicate);
                    }
                }


                var searchingUnselectionIndex = 0;

                while (this._searchingUnselectionBlocks.length != searchingUnselectionIndex) {
                    var searchBlock = this._searchingUnselectionBlocks[searchingUnselectionIndex];
                    this.blockUnselect(searchBlock, frustumPlanes, unselectionContent, allowDuplicate);
                    searchingUnselectionIndex++;
                }

                this._selectionContent.push(...selectionContent);
                this._unselectionContent.push(...unselectionContent);
            }

            this._selectionContent.sort(function (a: T, b: T) {

                if (b == null) {
                    return 1;
                }

                if (a == null) {
                    return -1;
                }

                if ((a as any).octantProjectedSize > (b as any).octantProjectedSize)
                    return 1;

                else
                    return -1;
            });

            for (var x = 0; x < this._selectionContent.length; x++) {

                (this._selectionContent[x] as any).renderPriority = x;
            }



            this._selectionContent.sort(function (a: T, b: T) {

                if (b == null) {
                    return 1;
                }

                if (a == null) {
                    return -1;
                }

                if ((a as any).renderPriority > (b as any).renderPriority)
                    return 1;

                else
                    return -1;
            });

        }
        catch (e) {
            
        }

        var selectionResult: SelectionContent = {
            selectedNodes: this._selectionContent,
            UnselectedNodes: this._unselectionContent
        };
        
        return selectionResult;
    }

    public IsInFrustumUnselect(boundingVectors: BABYLON.Vector3[], frustumPlanes: BABYLON.Plane[]): boolean {


        for (var p = 0; p < 6; p++) {
            var inCount = 8;

            for (var i = 0; i < 8; i++) {
                if (this.dotCoordinate(frustumPlanes[p], boundingVectors[i]) < 0) {
                    --inCount;
                } else {
                    break;
                }
            }
            if (inCount === 0) {

                return false;
            }
        }

        return true;
    }
    public IsEntryInFrustum(entry: any, frustumPlanes: BABYLON.Plane[]): boolean {

        return true;
    }

    public IsCompletelyInFrustum2(e: any, t: any) {
        for (var i = 0; i < 6; ++i)
            for (var n = t[i], r = 0; r < 8; ++r)
                if (this.dotCoordinate(t[i], e[r]) < 0)
                    return !1;
        return !0
    }
    public IsInFrustum2(e: any, t: any) {
        for (var i = 0; i < 6; ++i) {
            for (var n = !0, r = t[i], o = 0; o < 8; ++o)
                if (this.dotCoordinate(t[i], e[o]) >= 0) {
                    n = !1;
                    break
                }
            if (n)
                return !1
        }
        return !0
    }
    public IsInFrustum(boundingVectors: BABYLON.Vector3[], frustumPlanes: BABYLON.Plane[]): boolean {


        // true if all the points are on the wrong side of ONE of the planes
        for (var p = 0; p < 6; p++) {
            var inCount = 8;

            for (var i = 0; i < 8; i++) {
                if (this.dotCoordinate(frustumPlanes[p], boundingVectors[i]) < 0) {
                    --inCount;
                } else {
                    break;
                }
            }
            if (inCount === 0) {

                return false;
            }
        }

        return true;
    }

    public IsAllInFrustum(boundingVectors: BABYLON.Vector3[], frustumPlanes: BABYLON.Plane[]): boolean {

        // all 8 points need to be in all the planes
        for (var p = 0; p < 6; p++) {

            for (var i = 0; i < 8; i++) {
                if (this.dotCoordinate(frustumPlanes[p], boundingVectors[i]) < 0) {
                    return false;
                }
            }
        }

        return true;
    }

    public IsPointInFrustum(boundingVector: BABYLON.Vector3, frustumPlanes: BABYLON.Plane[]): boolean {


        for (var p = 0; p < 6; p++) {

            if (this.dotCoordinate(frustumPlanes[p], boundingVector) < 0) {
                return false;
            }
        }

        return true;
    }

    private add(vec1: BABYLON.Vector3, vec2: BABYLON.Vector3): BABYLON.Vector3 {

        return new BABYLON.Vector3(vec1._x + vec2._x, vec1._y + vec2._y, vec1._z + vec2._z);
    }

    private subtract(vec1: BABYLON.Vector3, vec2: BABYLON.Vector3): BABYLON.Vector3 {

        return new BABYLON.Vector3(vec1._x - vec2._x, vec1._y - vec2._y, vec1._z - vec2._z);
    }

    private subtract2D(vec1: BABYLON.Vector2, vec2: BABYLON.Vector2): BABYLON.Vector2 {

        return new BABYLON.Vector2(vec1.x - vec2.x, vec1.y - vec2.y);
    }

    private mult(vec1: BABYLON.Vector3, vec2: BABYLON.Vector3): number {

        return vec1._x * vec2._x + vec1._y * vec2._y + vec1._z * vec2._z;
    }

    private length(vec: BABYLON.Vector3): number {
        return Math.sqrt(vec._x * vec._x + vec._y * vec._y + vec._z * vec._z)
    }

    private length2D(vec: BABYLON.Vector2): number {
        return Math.sqrt(vec.x * vec.x + vec.y * vec.y)
    }

    public IntersectLineAndPlaneB(p1: BABYLON.Vector3, p2: BABYLON.Vector3, plane: BABYLON.Plane): BABYLON.Vector3 {

        var d = -1 * plane.d;

        var ba = new BABYLON.Vector3(p2._x - p1._x, p2._y - p1._y, p2._z - p1._z);
        var nDotA = BABYLON.Vector3.Dot(plane.normal, p1);
        var nDotBA = BABYLON.Vector3.Dot(plane.normal, ba);

        var magnitude = ((d - nDotA) / nDotBA);

        var ret = new BABYLON.Vector3(p1._x + (ba._x * magnitude), p1._y + (ba._y * magnitude), p1._z + (ba._z * magnitude));

        return ret;
    }
    private bboxIntersectsPoint(box: BABYLON.BoundingBox, point: BABYLON.Vector3) {

        var delta = -BABYLON.Epsilon;

        if (box.maximumWorld._x - point._x < delta || delta > point._x - box.minimumWorld._x)
            return false;

        if (box.maximumWorld._y - point._y < delta || delta > point._y - box.minimumWorld._y)
            return false;

        if (box.maximumWorld._z - point._z < delta || delta > point._z - box.minimumWorld._z)
            return false;

        return true;

    }

    private IntersectLineAndPlane(L1: BABYLON.Vector3, L2: BABYLON.Vector3, P1: BABYLON.Vector3, PN: BABYLON.Vector3): BABYLON.Vector3 {
        var dp1 = this.mult(PN, ((this.subtract(P1, L1))));
        var dp2 = this.mult(PN, (this.subtract(L2, L1)));


        if (dp2 != 0.0) {
            var u = (dp1) / (dp2);

            var div = this.subtract(L2, L1);

            div._x = div._x * u + L1._x;
            div._y = div._y * u + L1._y;
            div._z = div._z * u + L1._z;

            return div;
        }
        else {
            // The normal to the plane is perpendicular to the line.
            // Thus the line is either parallel to the plane and there are 
            // no solutions or the line is on the plane in which case there
            // are an infinite number of solutions...
            return null;
        }
    }

    public GetExtentDistanceToCamera(cameraPosition: BABYLON.Vector3, boundingVectors: BABYLON.Vector3[], frustumPlanes: BABYLON.Plane[], transformation: BABYLON.Matrix, viewport: BABYLON.Viewport): number {

        // Check if the camera is INSIDE the bounding vectors
        if (cameraPosition._x >= boundingVectors[0]._x && cameraPosition._y >= boundingVectors[0]._y && cameraPosition._z >= boundingVectors[0]._z &&
            cameraPosition._x <= boundingVectors[1]._x && cameraPosition._y <= boundingVectors[1]._y && cameraPosition._z <= boundingVectors[1]._z) {
            return 0;
        }

        var center = new BABYLON.Vector3(boundingVectors[1]._x - (boundingVectors[1]._x - boundingVectors[0]._x), boundingVectors[1]._y - (boundingVectors[1]._y - boundingVectors[0]._y), boundingVectors[1]._z - (boundingVectors[1]._z - boundingVectors[0]._z));
        var radius = this.length(new BABYLON.Vector3(boundingVectors[2]._x - boundingVectors[0]._x, boundingVectors[2]._y - boundingVectors[0]._y, boundingVectors[2]._z - boundingVectors[0]._z));

        var planes: BABYLON.Plane[] = [];

        planes.push(BABYLON.Plane.FromPoints(boundingVectors[0], boundingVectors[2], boundingVectors[3]));
        planes.push(BABYLON.Plane.FromPoints(boundingVectors[1], boundingVectors[2], boundingVectors[7]))
        planes.push(BABYLON.Plane.FromPoints(boundingVectors[1], boundingVectors[4], boundingVectors[6]));
        planes.push(BABYLON.Plane.FromPoints(boundingVectors[0], boundingVectors[3], boundingVectors[4]));
        planes.push(BABYLON.Plane.FromPoints(boundingVectors[0], boundingVectors[2], boundingVectors[7]));
        planes.push(BABYLON.Plane.FromPoints(boundingVectors[1], boundingVectors[3], boundingVectors[5]));

        var points: BABYLON.Vector3[] = [];

        points.push(boundingVectors[0]);
        points.push((boundingVectors[1]))
        points.push((boundingVectors[1]));
        points.push((boundingVectors[0]));
        points.push((boundingVectors[0]));
        points.push((boundingVectors[1]));

        var dif = this.subtract(cameraPosition, center);
        var distance = Number.MAX_VALUE;

        for (var x = 0; x < planes.length; x++) {

            var intersectPoint = this.IntersectLineAndPlane(cameraPosition, center, points[x], planes[x].normal);

            if (intersectPoint == null) {
                continue;
            }

            if (intersectPoint._x >= boundingVectors[0]._x && intersectPoint._y >= boundingVectors[0]._y && intersectPoint._z >= boundingVectors[0]._z &&
                intersectPoint._x <= boundingVectors[1]._x && intersectPoint._y <= boundingVectors[1]._y && intersectPoint._z <= boundingVectors[1]._z) {
                // Only if the intersect point is "inside" the face.
                distance = Math.min(distance, this.length(this.subtract(intersectPoint, cameraPosition)));
            }
        }

        // Lastly, compare the corners of the bounding box
        for (var x = 0; x < boundingVectors.length; x++) {

            var distanceToCorner = this.length(this.subtract(boundingVectors[x], cameraPosition));

            distance = Math.min(distance, distanceToCorner);
        }

        return distance;
    }
    public GetBoundingBoxDistanceToCamera(cameraPosition: BABYLON.Vector3, boundingVectors: BABYLON.Vector3[]): number {

        var closestPoint = this.closestPointOnBox(boundingVectors[0], boundingVectors[1], cameraPosition);
        return this.distanceBetweenPoints(cameraPosition, closestPoint);
    }

    public closestPointOnBox(minimum: BABYLON.Vector3, maximum: BABYLON.Vector3, point: BABYLON.Vector3) {

        if (point._x >= minimum._x && point._x <= maximum._x &&
            point._y >= minimum._y && point._y <= maximum._y &&
            point._z >= minimum._z && point._z <= maximum._z)
            return point;

        var closestPoint = new BABYLON.Vector3(
            Math.max(minimum._x, Math.min(point._x, maximum._x)),
            Math.max(minimum._y, Math.min(point._y, maximum._y)),
            Math.max(minimum._z, Math.min(point._z, maximum._z))
        );
        return closestPoint;
    }

    // Function to calculate the distance between two points
    public distanceBetweenPoints(point1: BABYLON.Vector3, point2: BABYLON.Vector3) {
        return BABYLON.Vector3.Distance(point1, point2);
    }

    public GetProjectedExtentSize(cameraPosition: BABYLON.Vector3, boundingVectors: BABYLON.Vector3[], frustumPlanes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, allowOutisdeViewport: boolean = false): number {

        // transformation is passed to the webworker, and loses its method calls (only data is passed). These methods are needed for the projection call
        // so we simply recreate a new matrix, that is a copy of transformation. Note, you cannot use copyTo/From, since transfomration is only data.

        var minX: number = null;;
        var minY: number = null;;

        var maxX: number = null;
        var maxY: number = null;
        var pointBehind = false;

        var projectedPoints: BABYLON.Vector2[] = [];
        var edgeKeys: number[] = [];
        var edgePoints: { [to: number]: number[]; } = {};

        var outsidePoints: number[] = [];

        var trans = new BABYLON.Matrix();
        trans.setRow(0, new BABYLON.Vector4(transformation[0], transformation[1], transformation[2], transformation[3]));
        trans.setRow(1, new BABYLON.Vector4(transformation[4], transformation[5], transformation[6], transformation[7]));
        trans.setRow(2, new BABYLON.Vector4(transformation[8], transformation[9], transformation[10], transformation[11]));
        trans.setRow(3, new BABYLON.Vector4(transformation[12], transformation[13], transformation[14], transformation[15]));

        for (var y = 0; y < 8; y++) {

            var projectedPoint = BABYLON.Vector3.Project(boundingVectors[y],
                BABYLON.Matrix.Identity(),
                trans as any,
                viewport);


            //check if the point is behind. If so, 
            if (this.dotCoordinate(frustumPlanes[0], boundingVectors[y]) < 0) {
                {
                    pointBehind = true;
                    continue;
                }
            }

            projectedPoints.push(new BABYLON.Vector2(projectedPoint._x, projectedPoint._y));


            if (maxX == null) {
                if (allowOutisdeViewport) {
                    minX = projectedPoint._x;
                    minY = projectedPoint._y;

                    maxX = projectedPoint._x, viewport.width;
                    maxY = projectedPoint._y;
                }
                else {
                    minX = Math.max(0, projectedPoint._x);
                    minY = Math.max(0, projectedPoint._y);

                    maxX = Math.min(projectedPoint._x, viewport.width);
                    maxY = Math.min(projectedPoint._y, viewport.height);
                }
            }
            else {

                minX = Math.min(projectedPoint._x, minX);
                minY = Math.min(projectedPoint._y, minY);

                maxX = Math.max(projectedPoint._x, maxX);
                maxY = Math.max(projectedPoint._y, maxY);
            }

        }


        var profileInfo = this.GetProfile(projectedPoints);

        edgePoints = profileInfo.edgePoints;
        edgeKeys = profileInfo.edgeKeys;

        var curve = this.GetCurve(edgePoints, edgeKeys, projectedPoints);


        if (curve.length > 0) {

            // Check if a corner of the viewport is totally in...
            projectedPoints = [];
            var c1 = new BABYLON.Vector2(0, 0);
            var c2 = new BABYLON.Vector2(viewport.width, 0);
            var c3 = new BABYLON.Vector2(0, viewport.height);
            var c4 = new BABYLON.Vector2(viewport.width, viewport.height);

            if (this.PointLiesInside2DPolygon(c1, curve, true)) {

                projectedPoints.push(c1);
            }

            if (this.PointLiesInside2DPolygon(c2, curve)) {

                projectedPoints.push(c2);
            }

            if (this.PointLiesInside2DPolygon(c3, curve)) {


                projectedPoints.push(c3);
            }

            if (this.PointLiesInside2DPolygon(c4, curve)) {

                projectedPoints.push(c4);
            }

            for (var x = 0; x < curve.length; x++) {

                fromPoint = curve[x];
                toPoint = x == curve.length - 1 ? curve[0] : curve[x + 1];

                if (this.CheckPointOutsideViewport(fromPoint, viewport) || this.CheckPointOutsideViewport(toPoint, viewport)) {

                    if (toPoint != null) {

                        var intersect = this.IntersectLineSegments(
                            new BABYLON.Vector3(fromPoint.x, fromPoint.y, 0),
                            new BABYLON.Vector3(toPoint.x, toPoint.y, 0),
                            new BABYLON.Vector3(c1.x, c1.y, 0),
                            new BABYLON.Vector3(c2.x, c2.y, 0));

                        if (intersect != null) {

                            projectedPoints.push(new BABYLON.Vector2(intersect._x, intersect._y));
                        }

                        intersect = this.IntersectLineSegments(
                            new BABYLON.Vector3(fromPoint.x, fromPoint.y, 0),
                            new BABYLON.Vector3(toPoint.x, toPoint.y, 0),
                            new BABYLON.Vector3(c1.x, c1.y, 0),
                            new BABYLON.Vector3(c3.x, c3.y, 0));


                        if (intersect != null) {

                            projectedPoints.push(new BABYLON.Vector2(intersect._x, intersect._y));
                        }

                        intersect = this.IntersectLineSegments(
                            new BABYLON.Vector3(fromPoint.x, fromPoint.y, 0),
                            new BABYLON.Vector3(toPoint.x, toPoint.y, 0),
                            new BABYLON.Vector3(c2.x, c2.y, 0),
                            new BABYLON.Vector3(c4.x, c4.y, 0));


                        if (intersect != null) {

                            projectedPoints.push(new BABYLON.Vector2(intersect._x, intersect._y));
                        }

                        intersect = this.IntersectLineSegments(
                            new BABYLON.Vector3(fromPoint.x, fromPoint.y, 0),
                            new BABYLON.Vector3(toPoint.x, toPoint.y, 0),
                            new BABYLON.Vector3(c3.x, c3.y, 0),
                            new BABYLON.Vector3(c4.x, c4.y, 0));

                        if (intersect != null) {

                            projectedPoints.push(new BABYLON.Vector2(intersect._x, intersect._y));
                        }
                    }
                }

                if (!this.CheckPointOutsideViewport(fromPoint, viewport)) {

                    projectedPoints.push(fromPoint);
                }
            }

            profileInfo = this.GetProfile(projectedPoints);
            edgePoints = profileInfo.edgePoints;
            edgeKeys = profileInfo.edgeKeys;
            curve = this.GetCurve(edgePoints, edgeKeys, projectedPoints);
        }


        if (pointBehind) {
            if (allowOutisdeViewport) {
                return Number.MAX_VALUE;
            }
            else {
                return viewport.width * viewport.height;
            }
        }


        if (curve.length > 0) {

            var areaSum = 0;

            for (var x = 0; x < curve.length; x++) {

                var fromPoint = curve[x];
                var toPoint = x == curve.length - 1 ? curve[0] : curve[x + 1];

                var addition = fromPoint.x * toPoint.y - fromPoint.y * toPoint.x;
                areaSum += addition;
            }

            areaSum /= 2;

            return Math.abs(areaSum);
        }


        if (minX == null || maxX == null || minY == null || maxY == null) {
            return -1;
        }

        if (!allowOutisdeViewport) {
            minX = Math.max(0, minX);
            minY = Math.max(0, minY);

            maxX = Math.min(viewport.width, maxX);
            maxY = Math.min(viewport.height, maxY);
        }

        return (maxX - minX) * (maxY - minY);
    }

    private GetProfile(projectedPoints: BABYLON.Vector2[]): any {

        var edgeKeys: number[] = [];
        var edgePoints: { [to: number]: number[]; } = {};

        for (var x = 0; x < projectedPoints.length; x++) {

            // determine which points make up the profile of the selected points. We do this by drawing a line between each point. If all other points lie on one side of this line,
            // then the 2 points make an "edge" of the profile.

            var p1 = projectedPoints[x];

            if (p1 == null)
                continue;

            for (var y = 0; y < projectedPoints.length; y++) {

                if (y != x) {

                    var p2 = projectedPoints[y];

                    if (p2 == null)
                        continue;

                    var signageToPoints: any = 0;
                    var edgeDetected = true;
                    var slope = (p2.y - p1.y) / (p2.x - p1.x);
                    var yIntercept = p1.y - slope * p1.x;

                    for (var z = 0; z < projectedPoints.length; z++) {

                        if (z != x && z != y) {

                            if (projectedPoints[z] == null)
                                continue;

                            var p3 = projectedPoints[z];

                            if (p3.y < (p3.x * slope + yIntercept)) {

                                if (signageToPoints == 0) {
                                    signageToPoints = -1;
                                }
                                else if (signageToPoints == 1) {
                                    edgeDetected = false;
                                    break;
                                }
                            }
                            else if (p3.y > (p3.x * slope + yIntercept)) {
                                if (signageToPoints == 0) {
                                    signageToPoints = 1;
                                }
                                else if (signageToPoints == -1) {
                                    edgeDetected = false;
                                    break;
                                }
                            }
                        }
                    }

                    if (edgeDetected) {

                        if (edgePoints[x] == null) {
                            edgePoints[x] = [];
                            edgeKeys.push(x);

                        }

                        edgePoints[x].push(y);
                    }
                }
            }
        }

        return {
            edgePoints: edgePoints,
            edgeKeys: edgeKeys
        }
    }

    private GetCurve(edgePoints: { [to: number]: number[]; }, edgeKeys: number[], projectedPoints: BABYLON.Vector2[]): BABYLON.Vector2[] {

        if (edgeKeys == null || edgePoints == null || edgeKeys.length == 0) {
            return [];
        }

        var curve: BABYLON.Vector2[] = [];
        var head = edgePoints[edgeKeys[0]];
        var from = edgeKeys[0];
        var to = head[0];
        var calculating = true;

        while (calculating) {

            var fromPoint = projectedPoints[from];
            var toPoint = projectedPoints[to];

            curve.push(fromPoint);

            if (to != edgeKeys[0]) {

                var temp = to;
                var nextToPoints = edgePoints[to];

                if (nextToPoints.length < 2) {

                    return [];
                }

                if (nextToPoints.length != 2) {
                    return [];
                }

                for (var z = 0; z < nextToPoints.length; z++) {

                    if (nextToPoints[z] != from) {
                        to = nextToPoints[z];
                    }
                }

                from = temp;
            }
            else {

                calculating = false;
            }
        }

        return curve;
    }

    public CheckPointOutsideViewport(point: BABYLON.Vector2, viewport: BABYLON.Viewport): boolean {

        if (point.x <= viewport.width && point.x >= 0 && point.y >= 0 && point.y <= viewport.height) {

            return false;
        }

        return true;
    }

    public PointLiesInside2DPolygon(point: BABYLON.Vector2, curve: BABYLON.Vector2[], debug: boolean = false): boolean {
        if (curve.length < 3)
            return false;

        var numCurvesIntersected = 0;

        for (var i = 0; i < curve.length; i++) {
            var b1 = curve[i];
            var b2 = i == curve.length - 1 ? curve[0] : curve[i + 1];

            var edgeIntersection = this.IntersectLines(
                new BABYLON.Vector3(point.x, point.y, 0),
                new BABYLON.Vector3(point.x + 1, point.y, 0),
                new BABYLON.Vector3(b1.x, b1.y, 0),
                new BABYLON.Vector3(b2.x, b2.y, 0));

            if (edgeIntersection.x > point.x) {
                if ((edgeIntersection.x <= Math.max(b1.x, b2.x) &&
                    edgeIntersection.x >= Math.min(b1.x, b2.x) &&
                    edgeIntersection.y <= Math.max(b1.y, b2.y) &&
                    edgeIntersection.y >= Math.min(b1.y, b2.y))) {
                    numCurvesIntersected++;
                }
            }
        }

        return numCurvesIntersected % 2 != 0 && numCurvesIntersected > 0;
    }

    public IntersectLines(a1: BABYLON.Vector3, a2: BABYLON.Vector3, b1: BABYLON.Vector3, b2: BABYLON.Vector3): BABYLON.Vector3 {
        var a = this.subtract(a2, a1);
        var b = this.subtract(b2, b1);
        var c = this.subtract(b1, a1);

        var axb = BABYLON.Vector3.Cross(a, b);
        var cxb = BABYLON.Vector3.Cross(c, b);


        var divisor = Math.pow(this.length(axb), 2);
        var z = this.mult(cxb, axb) / divisor;
        //return (a1 + a * ((cxb * axb) / Math.Pow(axb.Length(), 2)));
        return (this.add(a1, a.scale(z)));
    }

    public IntersectLineSegments(a1: BABYLON.Vector3, a2: BABYLON.Vector3, b1: BABYLON.Vector3, b2: BABYLON.Vector3): BABYLON.Vector3 {
        var a = this.subtract(a2, a1);
        var b = this.subtract(b2, b1);
        var c = this.subtract(b1, a1);

        var axb = BABYLON.Vector3.Cross(a, b);
        var cxb = BABYLON.Vector3.Cross(c, b);


        var divisor = this.length(axb) * this.length(axb);
        var z = this.mult(cxb, axb) / divisor;
        //return (a1 + a * ((cxb * axb) / Math.Pow(axb.Length(), 2)));
        var intersect = (this.add(a1, a.scale(z)));

        if (intersect._x + .001 < (Math.min(a1._x, a2._x)) || intersect._x + .001 < (Math.min(b1._x, b2._x)) ||
            intersect._y + .001 < (Math.min(a1._y, a2._y)) || intersect._y + .001 < (Math.min(b1._y, b2._y)) ||
            intersect._z + .001 < (Math.min(a1._z, a2._z)) || intersect._z + .001 < (Math.min(b1._z, b2._z)) ||
            intersect._x - .001 > (Math.max(a1._x, a2._x)) || intersect._x - .001 > (Math.max(b1._x, b2._x)) ||
            intersect._y - .001 > (Math.max(a1._y, a2._y)) || intersect._y - .001 > (Math.max(b1._y, b2._y)) ||
            intersect._z - .001 > (Math.max(a1._z, a2._z)) || intersect._z - .001 > (Math.max(b1._z, b2._z))) {

            return null;
        }

        if (intersect._x < 0 && intersect._x + .001 > 0) {

            intersect._x = 0;
        }

        if (intersect._y < 0 && intersect._y + .001 > 0) {

            intersect._y = 0;
        }

        return intersect;
    }


    public IsInFrustumByRange(boundingVectors: BABYLON.Vector3[], startIndex: number, frustumPlanes: BABYLON.Plane[]): boolean {


        for (var p = 0; p < 6; p++) {
            var inCount = 8;

            for (var i = startIndex; i < (startIndex + 8); i++) {
                if (this.dotCoordinate(frustumPlanes[p], boundingVectors[i]) < 0) {
                    --inCount;
                } else {
                    break;
                }
            }
            if (inCount === 0) {

                return false;
            }
        }

        return true;
    }

    public dotCoordinate(plane: BABYLON.Plane, point: BABYLON.Vector3): number {
        var val = ((((plane.normal._x * point._x) + (plane.normal._y * point._y)) + (plane.normal._z * point._z)) + plane.d);
        return val;
    }

    public static intersectsPoint(minBounds: BABYLON.Vector3, maxBounds: BABYLON.Vector3, point: BABYLON.Vector3): boolean {

        var delta = -BABYLON.Epsilon;

        if (maxBounds._x - point._x < delta || delta > point._x - minBounds._x)
            return false;

        if (maxBounds._y - point._y < delta || delta > point._y - minBounds._y)
            return false;

        if (maxBounds._z - point._z < delta || delta > point._z - minBounds._z)
            return false;

        return true;
    }
    public static getDistanceToBlock(block: any, point: BABYLON.Vector3) {
        var d1 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._minPoint, new BABYLON.Vector3(-1, 0, 0), point));
        var d2 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._minPoint, new BABYLON.Vector3(0, -1, 0), point));
        var d3 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._minPoint, new BABYLON.Vector3(0, 0, -1), point));

        var d4 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._maxPoint, new BABYLON.Vector3(-1, 0, 0), point));
        var d5 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._maxPoint, new BABYLON.Vector3(0, -1, 0), point));
        var d6 = Math.abs(BABYLON.Plane.SignedDistanceToPlaneFromPositionAndNormal(block._maxPoint, new BABYLON.Vector3(0, 0, -1), point));

        return Math.min(d1, d2, d3, d4, d5, d6);

    }

    public blockSelectBreadthFirst(block: OctreeBlock<T>, lodDistances: number[], cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, frustumPlanes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, selection: T[], unselection: T[], allowDuplicate?: boolean): boolean {

        var projectionSize = 0;

        // Test if this block is completely in the frustum. If it is, all of this blocks content and childrens content is selected.
        if (this.IsInFrustum(block._boundingVectors, frustumPlanes)) {

            var completelyInside = this.IsAllInFrustum(block._boundingVectors, frustumPlanes);
            if (block.blocks) {

                block.blocks.sort(function (a: OctreeBlock<T>, b: OctreeBlock<T>) {

                    if (b == null) {
                        return 1;
                    }

                    if (a == null) {
                        return -1;
                    }

                    if (Octree.intersectsPoint(a._minPoint, a._maxPoint, cameraPosition)) {
                        return 1;
                    }

                    if (Octree.intersectsPoint(b._minPoint, b._maxPoint, cameraPosition)) {
                        return -1;
                    }

                    var d1 = Octree.getDistanceToBlock(a, cameraPosition);
                    var d2 = Octree.getDistanceToBlock(b, cameraPosition);

                    if (d1 < d2) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                });


                {
                    if (!completelyInside) {
                        // Select the blocks closest to the camera first.
                        for (var index = 0; index < block.blocks.length; index++) {
                            var childBlock = block.blocks[index];

                            if (childBlock != null) {

                                this._searchingSelectionBlocks.push(childBlock);
                            }
                        }
                    }
                }
            }

            {
                var octantProjectedSize = this.GetBoundingBoxDistanceToCamera(cameraPosition, block._boundingVectors);
                // if this entire block is small, then there's NO point projecting the child entries, or any other child blocks

                if (octantProjectedSize <= FrustumStructures.RegionProjectionSize) {

                    var lodLevel = lodDistances.length;

                    for (var x = 0; x < lodDistances.length; x++) {
                    //for (var x = lodDistances.length - 1; x >= 0; x--) {
                        if (octantProjectedSize < lodDistances[x]) {
                            lodLevel = x + 1;
                            break;
                        }
                    }

                    if (completelyInside) {

                        for (var y = 0; y < block.childContent.length; y++) {

                            (block.childContent[y] as any).visibilityState = 1;
                            (block.childContent[y] as any).octantProjectedSize = octantProjectedSize;
                            (block.childContent[y] as any).lodLevel = lodLevel;

                            selection.push(block.childContent[y]);
                            objectIntersect = true;
                        }

                        this.numSkipped += block.childContent.length;
                    }

                    for (var y = 0; y < block.entries.length; y++) {

                        var objectIntersect = false;

                        //if (this.IsInFrustumByRange(block.pageExtents[y], 0, frustumPlanes)) {
                        {
                            (block.entries[y] as any).octantProjectedSize = octantProjectedSize;
                            (block.entries[y] as any).lodLevel = lodLevel;
                            (block.entries[y] as any).visibilityState = 1;

                            selection.push(block.entries[y]);
                            objectIntersect = true;
                        }

                        if (!objectIntersect) {
                            unselection.push(block.entries[y]);
                        }
                    }

                    return false;
                }
                else {
                    if (completelyInside) {
                        // Select the blocks closest to the camera first.
                        for (var index = 0; index < block.blocks.length; index++) {
                            var childBlock = block.blocks[index];

                            if (childBlock != null) {

                                this._completeSelectionBlocks.push(childBlock);
                            }
                        }
                    }
                    for (var y = 0; y < block.entries.length; y++) {

                        var objectIntersect = false;

                        if (this.IsInFrustum(block.pageExtents[y], frustumPlanes)) {
                        //if (this.IsInFrustumByRange(block.pageExtents[y], 0, frustumPlanes)) {
                        
                            var blockProjectedSize = this.GetBoundingBoxDistanceToCamera(cameraPosition, block.pageExtents[y]);

                            var lodLevel = lodDistances.length;

                            for (var x = 0; x < lodDistances.length; x++) {
                            //for (var x = lodDistances.length - 1; x >= 0; x--) {
                                if (blockProjectedSize < lodDistances[x]) {
                                    lodLevel = x + 1;
                                    break;
                                }
                            }

                            (block.entries[y] as any).octantProjectedSize = blockProjectedSize;
                            (block.entries[y] as any).lodLevel = lodLevel;
                            
                            var visiblityState = 0;

                            if (blockProjectedSize > FrustumStructures.PointProjectionSize) {

                                visiblityState = 3;
                            }
                            else if (blockProjectedSize > FrustumStructures.RegionProjectionSize) {
                                visiblityState = 2;
                            }
                            else {
                                visiblityState = 1;
                            }

                            (block.entries[y] as any).visibilityState = visiblityState;

                            selection.push(block.entries[y]);
                            objectIntersect = true;
                        }

                        if (!objectIntersect) {
                            unselection.push(block.entries[y]);
                        }
                    }
                }
            }
        }
        else {

            var p1 = new BABYLON.Vector3(block._minPoint._x, block._minPoint._y, block._minPoint._z);
            var p2 = new BABYLON.Vector3(block._minPoint._x, block._maxPoint._y, block._minPoint._z);
            var p3 = new BABYLON.Vector3(block._maxPoint._x, block._minPoint._y, block._minPoint._z);
            var p4 = new BABYLON.Vector3(block._maxPoint._x, block._maxPoint._y, block._minPoint._z);

            var p5 = new BABYLON.Vector3(block._minPoint._x, block._minPoint._y, block._maxPoint._z);
            var p6 = new BABYLON.Vector3(block._minPoint._x, block._maxPoint._y, block._maxPoint._z);
            var p7 = new BABYLON.Vector3(block._maxPoint._x, block._minPoint._y, block._maxPoint._z);
            var p8 = new BABYLON.Vector3(block._maxPoint._x, block._maxPoint._y, block._maxPoint._z);


            var points = [];
            points.push(p1);
            points.push(p2);
            points.push(p3);
            points.push(p4);
            points.push(p5);
            points.push(p6);
            points.push(p7);
            points.push(p8);

            block.blocks.sort(function (a: OctreeBlock<T>, b: OctreeBlock<T>) {

                if (b == null) {
                    return 1;
                }

                if (a == null) {
                    return -1;
                }

                if (Octree.intersectsPoint(a._minPoint, a._maxPoint, cameraPosition)) {
                    return 1;
                }

                if (Octree.intersectsPoint(b._minPoint, b._maxPoint, cameraPosition)) {
                    return -1;
                }

                var d1 = Octree.getDistanceToBlock(a, cameraPosition);
                var d2 = Octree.getDistanceToBlock(b, cameraPosition);

                if (d1 < d2) {
                    return 1;
                }
                else {
                    return -1;
                }
            });

            if (block.blocks) {
                for (var index = 0; index < block.blocks.length; index++) {
                    var childBlock = block.blocks[index];
                    if (childBlock != null) {

                        this._searchingUnselectionBlocks.push(childBlock);
                    }
                }
            }

            for (var y = 0; y < block.entries.length; y++) {

                unselection.push(block.entries[y]);
            }
        }

        return true;
    }

    public blockSelectAllIn(block: OctreeBlock<T>, lodDistances: number[], cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, frustumPlanes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, selection: T[], unselection: T[], allowDuplicate?: boolean): void {

        // Test if this block is completely in the frustum. If it is, all of this blocks content and childrens content is selected.


        {
            if (block.blocks) {

                block.blocks.sort(function (a: OctreeBlock<T>, b: OctreeBlock<T>) {

                    if (b == null) {
                        return 1;
                    }

                    if (a == null) {
                        return -1;
                    }

                    if (Octree.intersectsPoint(a._minPoint, a._maxPoint, cameraPosition)) {
                        return 1;
                    }

                    if (Octree.intersectsPoint(b._minPoint, b._maxPoint, cameraPosition)) {
                        return -1;
                    }

                    var d1 = Octree.getDistanceToBlock(a, cameraPosition);
                    var d2 = Octree.getDistanceToBlock(b, cameraPosition);

                    if (d1 < d2) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                });

                var octantProjectedSize = this.GetBoundingBoxDistanceToCamera(cameraPosition, block._boundingVectors);

                var lodLevel = lodDistances.length;

                for (var x = 0; x < lodDistances.length; x++) {
                //for (var x = lodDistances.length - 1; x >= 0; x--) {
                    if (octantProjectedSize < lodDistances[x]) {
                        lodLevel = x + 1;
                        break;
                    }
                }
                // if this entire block is small, then there's NO point projecting the child entries, or any other child blocks

                if (octantProjectedSize > FrustumStructures.RegionProjectionSize) {
                    for (var index = 0; index < block.blocks.length; index++) {
                        var childBlock = block.blocks[index];

                        if (childBlock != null) {

                            this._completeSelectionBlocks.push(childBlock);
                        }
                    }
                }
                else {
                    for (var y = 0; y < block.childContent.length; y++) {

                        (block.childContent[y] as any).visibilityState = 1;
                        (block.childContent[y] as any).octantProjectedSize = octantProjectedSize;
                        (block.childContent[y] as any).lodLevel = lodLevel;
                        selection.push(block.childContent[y]);
                        objectIntersect = true;
                    }

                    this.numSkipped += block.childContent.length;
                }

            }

            {
                for (var y = 0; y < block.entries.length; y++) {

                    var objectIntersect = false;

                    //if (this.IsInFrustumByRange(block.pageExtents[y], 0, frustumPlanes)) {
                    {
                        var octantProjectedSize = this.GetBoundingBoxDistanceToCamera(cameraPosition, block.pageExtents[y]);

                        var lodLevel = lodDistances.length;

                        for (var x = 0; x < lodDistances.length; x++) {
                        //for (var x = lodDistances.length - 1; x >= 0; x--) {
                            if (octantProjectedSize < lodDistances[x]) {
                                lodLevel = x + 1;
                                break;
                            }
                        }

                        var visiblityState = 0;

                        if (octantProjectedSize > FrustumStructures.PointProjectionSize) {

                            visiblityState = 3;
                        }
                        else if (octantProjectedSize > FrustumStructures.RegionProjectionSize) {
                            visiblityState = 2;
                        }
                        else {
                            visiblityState = 1;
                        }

                        (block.entries[y] as any).octantProjectedSize = octantProjectedSize;
                        (block.entries[y] as any).lodLevel = lodLevel;
                        (block.entries[y] as any).visibilityState = visiblityState;


                        selection.push(block.entries[y]);
                        objectIntersect = true;
                    }

                    if (!objectIntersect) {
                        unselection.push(block.entries[y]);
                    }
                }
            }
        }
    }

    public blockSelect(block: OctreeBlock<T>, cameraPosition: BABYLON.Vector3, frustumPlanes: BABYLON.Plane[], selection: T[], unselection: T[], allowDuplicate?: boolean): void {

        if (this.IsInFrustum(block._boundingVectors, frustumPlanes)) {

            if (block.blocks) {


                block.blocks.sort(function (a: OctreeBlock<T>, b: OctreeBlock<T>) {

                    if (b == null) {
                        return 1;
                    }

                    if (a == null) {
                        return -1;
                    }

                    if (Octree.intersectsPoint(a._minPoint, a._maxPoint, cameraPosition)) {
                        return 1;
                    }

                    if (Octree.intersectsPoint(b._minPoint, b._maxPoint, cameraPosition)) {
                        return -1;
                    }

                    var d1 = Octree.getDistanceToBlock(a, cameraPosition);
                    var d2 = Octree.getDistanceToBlock(b, cameraPosition);

                    if (d1 < d2) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                });

                // Select the blocks closest to the camera first.
                for (var index = 0; index < block.blocks.length; index++) {
                    var childBlock = block.blocks[index];
                    if (childBlock != null) {

                        this.blockSelect(childBlock, cameraPosition, frustumPlanes, selection, unselection, allowDuplicate);
                    }
                }
            }

            for (var y = 0; y < block.entries.length; y++) {
                var objectIntersect = false;


                if (this.IsInFrustum(block.pageExtents[y], frustumPlanes)) {
                //if (this.IsInFrustumByRange(block.pageExtents[y], 0, frustumPlanes)) {
                    selection.push(block.entries[y]);
                    objectIntersect = true;

                }
                if (!objectIntersect) {
                    unselection.push(block.entries[y]);
                }
            }
        }
        else {


            block.blocks.sort(function (a: OctreeBlock<T>, b: OctreeBlock<T>) {

                if (b == null) {
                    return 1;
                }

                if (a == null) {
                    return -1;
                }

                if (Octree.intersectsPoint(a._minPoint, a._maxPoint, cameraPosition)) {
                    return 1;
                }

                if (Octree.intersectsPoint(b._minPoint, b._maxPoint, cameraPosition)) {
                    return -1;
                }

                var d1 = Octree.getDistanceToBlock(a, cameraPosition);
                var d2 = Octree.getDistanceToBlock(b, cameraPosition);

                if (d1 < d2) {
                    return 1;
                }
                else {
                    return -1;
                }
            });

            if (block.blocks) {
                for (var index = 0; index < block.blocks.length; index++) {
                    var childBlock = block.blocks[index];
                    if (childBlock != null) {

                        this.blockUnselect(childBlock, frustumPlanes, unselection, allowDuplicate);
                    }
                }
            }

            for (var y = 0; y < block.entries.length; y++) {

                unselection.push(block.entries[y]);
            }
        }
    }

    public blockUnselect(block: OctreeBlock<T>, frustumPlanes: BABYLON.Plane[], selection: T[], allowDuplicate?: boolean): void {

        if (block.blocks) {
            for (var index = 0; index < block.blocks.length; index++) {
                var childBlock = block.blocks[index];
                if (childBlock != null) {

                    this.blockUnselect(childBlock, frustumPlanes, selection, allowDuplicate);
                }
            }
        }

        if (this.IsInFrustumUnselect(block._boundingVectors, frustumPlanes)) {

        }
        else {

            for (var y = 0; y < block.entries.length; y++) {
                if (!this.IsInFrustum(block.pageExtents[y], frustumPlanes)) {
                    selection.push(block.entries[y]);
                }
            }
        }
    }

    public static _CreateBlocks<T>(worldMin: BABYLON.Vector3, worldMax: BABYLON.Vector3, entries: T[], maxBlockCapacity: number, currentDepth: number, maxDepth: number, target: IOctreeContainer<T>, creationFunc: (entry: T, block: OctreeBlock<T>) => void): void {

    }
}

export class OctreeBlock<T> {
    public entries = new Array<T>();
    public pageExtents = new Array<BABYLON.Vector3[]>();
    public pageLargestObjectExtents = new Array<BABYLON.Vector3[]>();
    public childContent = new Array<T>();
    public blocks: Array<OctreeBlock<T>>;
    public id: number;
    public _depth: number;
    public _maxDepth: number;
    public _capacity: number;
    public _minPoint: BABYLON.Vector3;
    public _maxPoint: BABYLON.Vector3;
    public _boundingVectors = new Array<BABYLON.Vector3>();
    private _creationFunc: (entry: T, block: OctreeBlock<T>) => void;

    constructor(id: number, minPoint: BABYLON.Vector3, maxPoint: BABYLON.Vector3, capacity: number, depth: number, creationFunc: (entry: T, block: OctreeBlock<T>) => void) {

        this.id = id;
        this._capacity = capacity;
        this._depth = depth;
        this._creationFunc = creationFunc;

        this._minPoint = minPoint;
        this._maxPoint = maxPoint;

        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors.push(maxPoint.clone());

        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[2]._x = maxPoint._x;

        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[3]._y = maxPoint._y;

        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[4]._z = maxPoint._z;

        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[5]._z = minPoint._z;

        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[6]._x = minPoint._x;

        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[7]._y = minPoint._y;

        this.blocks = new Array<OctreeBlock<T>>(8);

        for (var x = 0; x < 8; x++) {
            this.blocks[x] = null;
        }
    }

    // Property
    public get capacity(): number {
        return this._capacity;
    }

    public get minPoint(): BABYLON.Vector3 {
        return this._minPoint;
    }

    public get maxPoint(): BABYLON.Vector3 {
        return this._maxPoint;
    }

    // Methods
    public addEntry(entry: T): void {

        this.entries.push(entry);
    }

    public addEntries(entries: T[]): void {
        for (var index = 0; index < entries.length; index++) {
            var mesh = entries[index];
            this.addEntry(mesh);
        }
    }

    public intersects(sphereCenter: BABYLON.Vector3, sphereRadius: number, selection: BABYLON.SmartArrayNoDuplicate<T>, allowDuplicate?: boolean): void {
        if (BABYLON.BoundingBox.IntersectsSphere(this._minPoint, this._maxPoint, sphereCenter, sphereRadius)) {
            if (this.blocks) {
                for (var index = 0; index < this.blocks.length; index++) {
                    var block = this.blocks[index];
                    block.intersects(sphereCenter, sphereRadius, selection, allowDuplicate);
                }
                return;
            }

            if (allowDuplicate) {
                selection.concat(this.entries);
            } else {
                selection.concatWithNoDuplicate(this.entries);
            }
        }
    }

    public intersectsRay(ray: BABYLON.Ray, selection: BABYLON.SmartArrayNoDuplicate<T>): void {
        if (ray.intersectsBoxMinMax(this._minPoint, this._maxPoint)) {
            if (this.blocks) {
                for (var index = 0; index < this.blocks.length; index++) {
                    var block = this.blocks[index];
                    block.intersectsRay(ray, selection);
                }
                return;
            }
            selection.concatWithNoDuplicate(this.entries);
        }
    }

    public createInnerBlocks(): void {
        Octree._CreateBlocks(this._minPoint, this._maxPoint, this.entries, this._capacity, this._depth, this._maxDepth, this, this._creationFunc);
    }
}